/* istanbul ignore file */
import React from 'react';
import { ListBreadcrumbItem, Breadcrumbs } from 'framework/ui/BreadCrumbs';
import { useVacancyUrl } from 'domain/recruiting/vacancy/vacancyRoute';

const VacanciesBreadcrumbs = ({ children = null }: { children?: React.ReactNode | React.ReactNode[] | null }) => {
  const { getListUrl } = useVacancyUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Vacancy" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default VacanciesBreadcrumbs;
